export default __webpack_public_path__ + "044b7f3ec427d4ddfd20e830c9126ec3.png";